exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notify-box[data-v-d1c02ef0] {\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  z-index: 9999999;\n  position: fixed;\n}\n.notify-box .custom-notify-box[data-v-d1c02ef0] {\n  width: 100%;\n}\n", ""]);

// exports
